import { Injectable } from '@angular/core';

export type Testimonial = {
  name: string;
  pet: string;
  quote: string;
  rating: number;
};

@Injectable({ providedIn: 'root' })
export class FeedbackSectionService {
  readonly testimonials: Testimonial[] = [
    {
      name: 'Priya Mehta',
      pet: 'Luna, British Shorthair',
      quote:
        'Luna is usually nervous, but the team kept everything calm and gentle. The updates were thoughtful and the finish was beautiful.',
      rating: 5
    },
    {
      name: 'Daniel Kim',
      pet: 'Milo, Golden Retriever',
      quote: 'The groomers clearly understand coat care. Milo came home soft, tidy, and totally relaxed.',
      rating: 5
    },
    {
      name: 'Sofia Alvarez',
      pet: 'Nori, Shiba Inu',
      quote: 'I loved the transparency. They explained what Nori needed and why, without any pressure.',
      rating: 5
    },
    {
      name: 'Amir Patel',
      pet: 'Poppy, Cockapoo',
      quote: 'Clean studio, caring hands, and a gorgeous result. Poppy trims are consistent every time.',
      rating: 5
    }
  ];
}
